import { Flex } from '@chakra-ui/react';
import { useCoinMode } from '@ui/hooks/useCoinMode';
import { useUseLcroPartnerCardsData } from '@ui/hooks/useUseLcroPartnerCardsData';
import React from 'react';

import UseLcroDirectlyPartnerCard from './UseLcroDirectlyPartnerCard';

function UseLcroDirectlyPartnerCards() {
  const coinMode = useCoinMode();
  const { partnerCardData } = useUseLcroPartnerCardsData(coinMode);

  return (
    <>
      <Flex flexDir="column" w="full" gap={4}>
        {partnerCardData.map((data, i) => (
          <UseLcroDirectlyPartnerCard key={i} {...data} />
        ))}
      </Flex>
    </>
  );
}

export default UseLcroDirectlyPartnerCards;
